/**
 * @generated SignedSource<<9f51b28be209c3405ce3ec65a2004220>>
 * @relayHash 5c89aa17fb54b80d65c3bd83fc590fd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bbc87df05548680a32da2fd28b2be7082d82695f728fe7cca50aa1ad7138e238

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardEmbedQuery } from './src_jiraBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "bbc87df05548680a32da2fd28b2be7082d82695f728fe7cca50aa1ad7138e238",
    "metadata": {},
    "name": "src_jiraBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
